import _slicedToArray from "/var/www/braunschweig.de/apps/lichtparcours-2020-preview/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/var/www/braunschweig.de/apps/lichtparcours-2020-preview/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.find-index";
import * as React from 'react';
import { useContext, useState, useEffect } from 'react';
export var getCurrentZone = function getCurrentZone(bps) {
  var width = window.innerWidth;
  var outZone = bps.findIndex(function (bp) {
    return width < bp;
  });
  if (outZone < 0) outZone = bps.length;
  return outZone - 1;
};

var getMqLists = function getMqLists(bps) {
  return bps.map(function (bp, i) {
    var nextBp = bps[i + 1];
    return window.matchMedia("(min-width: ".concat(bp, "px) ").concat(nextBp ? "and (max-width: ".concat(nextBp - 1, "px)") : ''));
  });
};

export var ZoneContext = React.createContext(0);
export var useZone = function useZone() {
  return useContext(ZoneContext);
}; // bootstrap default breakpoints

export var ZoneManager = function ZoneManager(_ref) {
  var _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? [576, 767, 991, 1199] : _ref$breakpoints,
      _ref$defaultZone = _ref.defaultZone,
      defaultZone = _ref$defaultZone === void 0 ? 0 : _ref$defaultZone,
      children = _ref.children;
  var bps = [0].concat(_toConsumableArray(breakpoints)); // SSR renders without calling `useEffect` hooks (thus falling back to `defaultZone`), that's
  // why we need to render with the `defaultZone` on the client first to re-hydrate the dom

  var _useState = useState(defaultZone),
      _useState2 = _slicedToArray(_useState, 2),
      zone = _useState2[0],
      setZone = _useState2[1];

  useEffect(function () {
    setZone(getCurrentZone(bps));

    var listenerForZone = function listenerForZone(i) {
      return function (e) {
        if (!e.matches) return;
        setZone(i);
      };
    };

    var listeners = [];
    var mqLists = getMqLists(bps);
    mqLists.forEach(function (mqList, i) {
      var listener = listenerForZone(i);
      mqList.addListener(listener);
      listeners.push(listener);
    });
    return function () {
      mqLists.forEach(function (mqList, i) {
        return mqList.removeListener(listeners[i]);
      });
    };
  }, // We use the whole bps array as deps. Using `[bps]` would re-execute `useEffect` on each render
  bps);
  return React.createElement(ZoneContext.Provider, {
    value: zone
  }, children);
};